/**
 * MIRRORED FILE: keep byte-identical in Prologue and Tributary.
 *   prologue:  src/components/ProgressBars/LevelTracker/levelDefinitions.ts
 *   tributary: src/app/(pages)/contribute/[school]/components/level-tracker/level-definitions.ts
 * Rule: .ai/constitution (contribution progress parity). Change both copies in twin PRs.
 *
 * The ordered level definitions. This list alone decides how many levels exist,
 * their order and their icons: the tracker shows min(rungs from the API, entries
 * here) levels (zoomed-in-milestones ARD decision #4). Each app supplies the
 * title and description for every `key`. Adding, removing or reordering an entry
 * means updating each app's level text in the same pair of PRs.
 */
export const LEVEL_DEFINITIONS: ReadonlyArray<{ readonly key: string; readonly icon: string }> = [
  { key: 'table', icon: 'book-open' },
  { key: 'classroom', icon: 'party-popper' },
  { key: 'cafeteria', icon: 'medal' },
]
